<!--专家-->
<template>
    <div class="sec content mt20" id="expert">
        
        <div class="tab-head myflex-v">
            <div class="tab-item tabTitle myflex-v">
                <i class="el-icon-pie-chart title-icon myhide"></i><img src="@/assets/img/icon3.png" class="title-icon-img" /><span>全民终身学习社区艺术教育资源共享行动专家库</span>
            </div>
            <div class="myflex-lv ml20 myhide">
                <div :class="['searchItem',{'active':searchActive==0}]" @click="search(0)">推荐专家</div>
                | 
                <div :class="['searchItem',{'active':searchActive==1}]" @click="search(1)">本地专家</div>
            </div>
            <div class="sec-right-up myflex-v marginauto-l">
                <el-input placeholder="请输入要查询的教师姓名" v-model="searchval" class="mr15 width200 myhide" size="small">
                    <i slot="suffix" class="el-input__icon el-icon-search" @click="startSearch"></i>
                </el-input>
                <div class="look-more" @click="toList">查询与查看更多<i class="el-icon-arrow-right"></i></div>
            </div>
        </div>
        <div v-loading="loading">
            <div class="pad15 scroll-container expert-item-box myflex" v-if="list.length>0">
                <div class="expert-item" v-for="(item,index) in list" :key="index" @click="toExpertTeacherDetail(item.userId,item.photoPath,item.userName,item.majorName)">
                    <el-image 
                        :src="art.addOssResize(item.photoPath ? item.photoPath : art.defaultHeadPhoto,180)" fit="cover" lazy class="expert-cover" scroll-container="#app">
                    </el-image>
                    <div class="expear-name ellipsis1">{{checkPhone(item.userName)}}</div>
                </div>
                <div class="linkItem marginauto-l myflex-lv" @click="toList">
                    <div class="text-center fweight">
                        <div>进入</div>
                        <div>专家库</div>
                        <img src="@/assets/img/cert/arrow.png" class="arrow"/>
                    </div>
                </div>
            </div>
            <div v-else class="pad15 nodata">暂无数据~</div>
        </div>
    </div>
</template>

<style lang="scss" scoped>
    .searchItem{padding:10px 5px;cursor:pointer;font-weight:600;}
    .searchItem.active{color:$theme-color;}
    .expert-item-box{overflow:auto;white-space:nowrap;}
    .expert-item{margin-right:15px;width:92px;display:inline-block;}
    .expert-item:last-child{margin-right:0;}
    .expert-cover{width:92px;height:92px;border:1px solid #ddd;}
    .expear-name{width:100%;text-align:center;font-size:14px;padding:5px 0 0px 0;}
    .nodata{height:152px;}
    .linkItem{width:92px;height:92px;border-radius:10px;@include bg-themecolor(.95);color:#fff;font-size:14px;cursor:pointer;}
    .linkItem:hover{@include bg-themecolor(1);}
    @media screen and(max-width:1200px){
        .expert-item-box{flex-wrap:wrap;}
        .expert-item{margin:7px 15px 7px 0;}
        .expert-item:last-child{margin-right:15px;}
        .linkItem{margin:7px 0;}
    }
</style>

<script>
import { mapState } from 'vuex'
import CourseListItem from '@/components/CourseListItem.vue';
export default {
    name: "shequCourse",
    components: {
        CourseListItem,
    },
    data(){
        return {
            art: art,
            searchval: '',
            searchActive: 1,
            list: [],
            loading: true,
        }
    },
    computed:{
        cityName(){
            return this.$store.state.cityInfo.cityName;
        }
    },
    methods: {

        getList(type){
            //type 1:推荐老师列表 0:本地老师列表
            var data = {type:type,pageNum:1,pageSize:10}
            if( type==1 ){
                data.city = this.cityName;
            }
            this.$api.web.websitContentSelectProfessorList(data).then(res=>{
                this.list = res.body.professorInfoList;
                this.loading = false;
            }).catch(res=>{
                this.loading = false;
            })
        },

        //切换列表
        search: function(ind){
            this.searchActive = ind;
            var vm = this;
            //本地专家
            if( ind==2 ){
                if( vm.cityName ){
                    vm.getList(1);
                }else{
                    console.log(vm.$store.getters['cityInfo/baiduLocation']);
                    vm.$store.getters['cityInfo/baiduLocation']((res)=>{
                        vm.cityName = res;
                        console.log(vm.cityName);
                        vm.getList(0);
                    })
                }
            }
            //推荐专家
            else{
                vm.getList(0);
            }
        },

        //专家老师列表页面
        toList(){
            const newurl = this.$router.resolve({path: '/expertTeacherList', query: {isExpert:1}})
            window.open(newurl.href,'_blank');
        },

        //专家老师详情页面
        toExpertTeacherDetail: function(id,photoPath,userName,majorName){
            const newurl = this.$router.resolve({path: '/expertTeacherDetail', query: {
                id: id,
                headphoto: photoPath,
                userName: userName,
                majorName: majorName,
            }})
            window.open(newurl.href,'_blank');
            art.delayRollAuto();
        },
        //如果是手机号，中间打*
        checkPhone(str){
            if( (/^1[2|3|4|5|6|7|8|9][0-9]\d{4,8}$/.test(str)) ){ 
                var a = str.substr(0,3);
                var b = str.substr(-5,4);
                return a +'****'+ b;
            }else{
                return str;
            }
        },
        startSearch(){

        }
    },

    created(){
    },
    mounted(){
        setTimeout(() => {
           this.getList(0); 
        }, 1500);
    },
}
</script>